import { FillStyleOverrides, PaintTarget } from '@gift/types/plugins/paintTargets';
import { Json } from '@gift/types/Json';

export function mapTo<T>(target: PaintTarget, options: { [key in PaintTarget]: T }) {
    return options[target];
}

export function mapFillStyleTo(
    target: PaintTarget,
    input: { fillStyle: string },
    overrides: FillStyleOverrides,
    palette: Json.Palette
) {
    return mapTo(target, {
        mockup: resolve(input.fillStyle, overrides.mockupFillStyle, palette),
        icon: resolve(input.fillStyle, overrides.iconFillStyle, palette),
        print: resolve(input.fillStyle, overrides.printFillStyle, palette),
        preview3d: resolve(input.fillStyle, overrides.preview3dFillStyle, palette)
    });
}

const resolve = (
    inputFillStyle: string,
    fillStyleOverride: string | undefined,
    palette: Json.Palette
) => {
    if (fillStyleOverride) {
        return palette?.[fillStyleOverride] || fillStyleOverride;
    } else {
        return palette?.[inputFillStyle] || inputFillStyle;
    }
};